import { doc, writeBatch } from '@battleops/localstore';
import { chunkWrites } from '@battleops/shared';
import { db } from './store';

// Commit a command's writes (shared/commands: [{ op, path, data, merge }]) as ONE local batch = one
// outbox group = one server transaction. Over 200 writes → several groups, in order.
export async function commitWrites(writes, opts = {}) {
  if (!writes?.length) return [];
  const receipts = [];
  for (const chunk of chunkWrites(writes)) {
    const batch = writeBatch(db);
    for (const w of chunk) {
      const [col, id, ...rest] = w.path.split('/');
      const ref = doc(db, col, id, ...rest);
      if (w.op === 'delete') batch.delete(ref);
      else if (w.op === 'update') batch.update(ref, w.data);
      else batch.set(ref, w.data, w.merge ? { merge: true } : undefined);
    }
    receipts.push(await batch.commit(opts));
  }
  return receipts;
}
